/**
 * Phase 16a (D-259, D-261): the bireysel edition's legal texts, drafts until a lawyer approves them
 * (`docs/legal/taslak/`). A sign-up records the version of the terms it accepted and of the KVKK text shown beside
 * it; a test keeps these versions equal to the files' `surum`. Phase 16c: the checkout records the Ön Bilgilendirme
 * Formu's and the Mesafeli Satış Sözleşmesi's (legal_acceptances); a text that changes gets a new version.
 */
export type LegalDocumentKey = 'terms' | 'privacy' | 'cookies' | 'preInformation' | 'distanceSales';

export interface LegalDocument {
  /** the page's address: /yasal/<slug>, and the file's name in docs/legal/taslak/ */
  slug: string;
  title: string;
  version: string;
  draft: boolean;
}

export const LEGAL_DOCUMENTS: Record<LegalDocumentKey, LegalDocument> = {
  terms: { slug: 'kullanim-kosullari', title: 'Kullanım Koşulları', version: 'taslak-2026-11-02.1', draft: true },
  privacy: { slug: 'kvkk-aydinlatma', title: 'KVKK Aydınlatma Metni', version: 'taslak-2026-11-02', draft: true },
  // 16c.1: only necessary cookies in the types table, the remembered session's 30 days; the two purchase texts take
  // their prices and rights from the order
  cookies: { slug: 'cerez-politikasi', title: 'Çerez Politikası', version: 'taslak-2026-11-03.1', draft: true },
  preInformation: { slug: 'on-bilgilendirme-formu', title: 'Ön Bilgilendirme Formu', version: 'taslak-2026-11-03', draft: true },
  distanceSales: { slug: 'mesafeli-satis-sozlesmesi', title: 'Mesafeli Satış Sözleşmesi', version: 'taslak-2026-11-03', draft: true },
};

/**
 * Phase 16c: the checkout's second box (the Ön Bilgilendirme Formu's §6): the service starts at once and the right of
 * withdrawal does not apply. Its words are recorded with this version (legal_acceptances: immediateStart).
 */
export const IMMEDIATE_START = {
  version: 'onay-2026-11-02',
  text: "Pro'nun hemen başlamasını istiyorum. Hemen başlayan dijital hizmetlerde cayma hakkı olmadığını biliyorum.",
} as const;
